/**
 * Whether the sidebar is collapsed to a rail of icons.
 *
 * Remembered per browser, because it is a working preference: someone who
 * wants the extra width wants it every day, not once. Storage can throw or
 * come back empty — a private window, cleared site data — so it never decides
 * whether the app works, only how it looks.
 */
import { useEffect, useState } from 'react';

const KEY = 'bms.sidebar.collapsed';

function read(): boolean {
  try {
    return window.localStorage.getItem(KEY) === 'true';
  } catch {
    return false;
  }
}

export function useSidebarCollapsed(): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState(read);

  useEffect(() => {
    try {
      window.localStorage.setItem(KEY, String(collapsed));
    } catch {
      // Not worth telling anyone about: the sidebar still works, it just
      // forgets between visits.
    }
  }, [collapsed]);

  return [collapsed, () => setCollapsed((value) => !value)];
}
